<template>
  <div class="order-item-component">
    <order-title :order="order"></order-title>
    <table
      v-if="order.deposit"
      class="order-table"
      cellpadding="0"
      cellspacing="0"
    >
      <tbody>
        <tr
          class="tr-4"
          :class="{'tr-5' : order.coupons && order.coupons.length}"
        >
          <td>
            <ul>
              <li>
                <p class="fl">订金</p>
                <p class="fr hour-num">1</p>
              </li>
            </ul>
          </td>

          <td
            rowspan="1"
            class="text-center"
          >
            <td-money :order="order" />
          </td>
          <!-- 是否有优惠 -->
          <td
            v-if="order.coupons && order.coupons.length"
            rowspan="1"
            class="text-center"
          >
            <td-on-sale :order="order" />
          </td>
          <!-- 状态 -->
          <td
            rowspan="1"
            class="text-center"
          >
            <span>{{order.statusName}}</span>
          </td>

          <td
            rowspan="1"
            class="text-center pt-5"
          >
          <span>ewrre</span>
            <template v-if="order.status === 'TO_PAY' && !order.old && order.suCanPay === 1">
              <vk-btn @click="goPay(order.coursePackIdList, order.depositPayOrderId, '1', '1', order.studentId, order.currency)">立即支付</vk-btn>
            </template>
            <vk-btn
              plain
              v-if="order.canCanceled"
              @click="cancelPay(order)"
            >取消订单</vk-btn>
            <template v-if="showAgreement(order)">
              <template v-for="(v, i) in order.formatVersions">
                <a
                  :key="i"
                  class="agreement-a click-a"
                  @click="getAgreement(v.version, order.studentId, order.versions, order.serialNumber)"
                >
                  《{{v.versionName}}》
                </a>
              </template>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      class="order-table"
      cellpadding="0"
      cellspacing="0"
    >
      <tbody>
        <template v-if="order.packOrderDetails">
          <tr
            class="tr-4"
            :class="{'tr-5' : order.coupons && order.coupons.length}"
          >
            <td>
              <ul>
                <li
                  v-for="(o, i) in order.packOrderDetails"
                  :key="i"
                >
                  <template v-if="showCourseName(o)">
                    <p class="fl">
                      <span>{{changeCourseName(order, o)}}</span>
                      <span
                        class="free"
                        v-if="o.isFree"
                      >赠</span>
                    </p>
                    <p class="fr hour-num">{{o.classHour}}</p>
                    <div v-if="showStudyEval(order, o)">（ 上述VIPKID主修课程含<span>{{Math.floor(o.classHour / 6)}}</span>次学习周期测评 ）</div>
                  </template>
                </li>
                <template v-if="order.useCoupon">
                  <li
                    v-for="(o, i) in order.gifts"
                    :key="i"
                  >
                    <p class="fl">
                      <span>{{o.name}}</span>
                      <span class="free">赠</span>
                    </p>
                    <p class="fr hour-num">{{o.value}}</p>
                  </li>
                </template>
              </ul>
            </td>
            <td
              rowspan="1"
              class="text-center"
            >
              <td-money :order="order"></td-money>
            </td>
            <td
              v-if="order.coupons && order.coupons.length"
              rowspan="1"
              class="text-center"
            >
              <td-on-sale :order="order"></td-on-sale>
            </td>
            <td
              rowspan="1"
              class="text-center"
            >
              <span>{{order.statusName}}</span>
            </td>
            <td
              rowspan="1"
              class="text-center pt-5"
            >
              <vk-btn
                plain
                v-if="order.canCanceled"
                @click="cancelPay(order)"
              >取消订单</vk-btn>
              <template v-if="!order.open">
                <template v-if="order.status === 'TO_PAY' && !order.old">
                  <template v-if="order.suCanPay === 1">
                    <vk-btn
                      @click="goPay(order.coursePackIdList, order.payOrderId, '1', '0', order.studentId, order.currency)"
                      v-if="!isChangeOrder(order)"
                    >立即支付</vk-btn>
                    <span v-if="order.expiredDate">{{'课程有效期至' + order.expiredDate}}</span>
                  </template>
                </template>
                <template v-if="order.status === 'PAID'">
                  <template v-if="order.suCanPay === 1">
                    <vk-btn disabled>立即支付</vk-btn>
                  </template>
                </template>
              </template>

              <template v-if="showAgreement(order)">
                <template v-for="(v, i) in order.formatVersions">
                  <a
                    :key="i"
                    class="agreement-a click-a"
                    @click="getAgreement(v, order.studentId, order.versions, order.serialNumber)"
                  >
                    《{{v.versionName}}》
                  </a>
                </template>
              </template>
            </td>
          </tr>

          <tr v-if="order.totalPrice && order.haveMajor">
            <td
              colspan="5"
              style="text-align:left;padding:13px 0 13px 20px"
            >
              <span>（注：为保证和提高教学质量，VIPKID可根据学员实际学习情况对VIPKID主修课程所含学习周期测评数量进行相应调整）</span>
            </td>
          </tr>

          <tr v-if="order.ipadPresentOrder && order.status === 'TO_PAY'">
            <td
              colspan="5"
              style="text-align:left;padding:13px 20px"
            >
              <p v-if="order.ipadShipImmediate"> Apple Ipad 发货方式：立即发货</p>
              <p class="contacts-person">
                提醒：关于Apple iPad发货及课程退费规则等，请您在支付前详细阅读《课程服务协议》及《赠品用户须知》。
              </p>
            </td>
          </tr>

          <tr v-if="showShippingAddress(order)">
            <td
              colspan="5"
              style="text-align:left;padding:13px 20px"
              class="address-info-module"
            >
              <p>收货信息<span v-if="order.ipadPresentOrder">（若有变更请及时联系您的课程顾问）</span></p>
              <p class="contacts-person">
                <span>收件人：</span>
                <span>&nbsp;&nbsp;&nbsp;{{order.shipAddress.customerName}}</span>
                <span class="ml-15">联系电话：</span>
                <span>{{order.shipAddress.customerMobile}}</span>
              </p>
              <p class="contacts-person">
                <span class="address-details-title">收货地址：</span>
                <span class="adress-details">{{order.shipAddress.province}}{{order.shipAddress.city}}{{order.shipAddress.district}}{{order.shipAddress.address}}</span>
              </p>
              <p
                class="contacts-person"
                v-if="order.ipadPresentOrder"
              >
                <span class="order-body-list-btn">已确认地址</span>
              </p>
            </td>
          </tr>

          <tr v-if="showShippingAddressAtOnceBtn(order)">
            <td
              colspan="5"
              style="text-align:left;padding:13px 20px"
            >
              <p>尊敬的家长，您的订单包含贵重实物，请确认收货地址，否则实物订单无法发货。</p>
              <p class="tip-info">（VIPKID会使用您本次确认的收货地址进行邮寄）</p>
              <p>
                <vk-btn @click="sureAddress(order.studentId, order.id)">立即确认收货地址</vk-btn>
              </p>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td
              colspan="3"
              style="height:27px"
            ></td>
          </tr>
        </template>

        <!-- 拆单 -->
        <template v-if="isSplitOrder(order)">
          <tr class="tr-row">
            <td></td>
            <td>{{priceUnit}}{{order.depositPrice}}订金</td>
            <td>已支付</td>
            <td></td>
          </tr>
        </template>

        <template v-if="isSplitOrder(order) || isSplitOrder2(order)">
          <tr
            v-for="(o, i) in order.payOrders"
            :key="i"
            class="tr-row"
          >
            <td></td>
            <td>
              <p class="price">
                <span v-if="o.ipadPresentPay">{{priceUnit}}{{o.price}}(首付款)</span>
                <span v-else>{{priceUnit}}{{o.price}}</span>
              </p>
            </td>
            <td>
              <p>{{o.statusName}}</p>
            </td>
            <!-- <td v-if="order.coupons && order.coupons.length"></td> -->
            <td class="pt-5">
              <template v-if="o.status === 'TO_PAY' && order.suCanPay === 1">
                <vk-btn @click="goPay(order.coursePackIdList, o.id, '2', '0', order.studentId, order.currency)">立即支付</vk-btn>
              </template>
              <template v-if="o.status === 'PAID' && order.suCanPay === 1">
                <vk-btn disabled>立即支付</vk-btn>
              </template>
            </td>
          </tr>
        </template>

        <template v-if="order.newStudentPolicyFlag && !hidePolicy(order)">
          <tr class="table-footer">
            <td colspan="4">
              <div class="policy-module">
                <span v-if="order.versions.includes('v6.1')">全项进阶课课程包政策</span>
                <span v-else>新生政策</span>
              </div>
              <div
                @click="$emit('show-policy-dialog', order)"
                class="policy-module"
                v-for="(o, k) in getPolicyList(order)"
                :key="k"
              ><img
                  class="hook-img"
                  src="@/assets/images/order/hook.png"
                />
                <span>{{o.name}}</span>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

</template>

<script>
import orderTitle from './orderTitle'
import tdMoney from './tdMoney'
import tdOnSale from './tdOnSale'
export default {
  props: {
    order: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    orderTitle, tdMoney, tdOnSale
  },
  data() {
    return {
      KPCourseIds: [153444458, 153469100]
    }
  },
  computed: {
    priceUnit() {
      return this.order.currency === 'HKD' ? 'HKD ' : '¥'
    }
  },
  methods: {
    // 是否展示课程包名称
    showCourseName(o) {
      return !(o.courseName === 'IT Test-电脑检测' || o.courseName === '全程中教指教')
    },
    // 根据订单的status ，获取不同的政策列表
    getPolicyList({ status, versions }) {
      const policyList = [{
        key: 0,
        name: '免费试学期'
      }, {
        key: 1,
        name: '课程有效期'
      }, {
        key: 2,
        name: '退费有效期'
      }, {
        key: 3,
        name: '休学政策'
      }]
      // 如果是 'TO_PAY' 状态 ，只展示免费试学期
      if (status === 'TO_PAY') {
        return policyList.slice(0, 1)
      }
      // 如果是v6.1 , 只展示免费试学期  和 课程有效期
      if (versions.includes('v6.1')) {
        return policyList.slice(0, 2)
      }
      return policyList
    },
    goPay(coursePackIdList, orderId, dataFlg, orderType, studentId, currency) {
      // 如果是KPCourse 需要去手机端或者公众号支付，因为pc端无法选择上课时间
      console.log(coursePackIdList)
      if (!coursePackIdList) {
        this.$emit('goPay', orderId, dataFlg, orderType, studentId, currency)
        return
      }
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/packorder/getCoursePackDTOByPackId',
        params: { packId: coursePackIdList[0] }
      }).then(res => {
        console.log(res)
        if (res.data && res.data.code == 200) {
          let data = res.data.data
          if (data && data.coursePackItemWebList && data.coursePackItemWebList.length > 0) {
            let isKPCourse = false
            for (let i = 0; i < data.coursePackItemWebList.length; i++) {
              console.log
              if (this.KPCourseIds.includes(data.coursePackItemWebList[i].courseId)) {
                isKPCourse = true
                break;
              }
            }
            if (isKPCourse) {
              this.$alert('请在“VIPKID英语”APP或“VIPKID大米科技“公众号 完成支付')
            } else {
              this.$emit('goPay', orderId, dataFlg, orderType, studentId, currency)
            }
          } else {
            this.$emit('goPay', orderId, dataFlg, orderType, studentId, currency)
          }
        } else {
          this.$alert(res.data.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$alert('查询CourseId失败，无法继续，请在“VIPKID英语”APP或“VIPKID大米科技“公众号 完成支付')
      })
      // 
    },
    // 判断是否是兑换订单
    isChangeOrder(order) {
      return order.type === 3 && order.giveReason === '37'
    },
    // 判断订单是否存在一下版本中任意一个，存在就不展示新生政策
    hidePolicy(order) {
      const versions = Array.isArray(order.versions) ? order.versions : []
      return versions.some(v => {
        return ['v5', 'v5.1', 'v6', 'v6.2', 'v7'].includes(v)
        // return ['v1', 'v2', 'v3', 'v3-esl', 'v3-201810', 'v4', 'v6.1', 'exv1', 'exv2', 'ex-apple-pay', 'exChannel-v1', 'exChannel-v2', 'ex-ipad', 'ex-ipad-201901', 'ex-gift-201902'].includes(v)
      })
    },
    // 某种情况下需要修改展示名字
    changeCourseName(order, o) {
      return (this.showStudyEval(order, o) && o.courseName === 'Major Course-VIPKID主修课') ? 'MajorCourse-VIPKID主修课' : o.courseName
    },
    // 是否展示含多少次学习测评
    showStudyEval(order, o) {
      return order.realTotalPrice && o.classHour > 5 && (o.courseName === 'VIPKID美国小学课程' || o.courseName === 'Major Course-VIPKID主修课')
    },
    // 是否显示协议 status === 'PAY_CONFIRMED'
    // 针对特殊用户（公司客户）的订单号做服务协议隐藏处理 订单号为：（201708061155448578424500，201701101459098598989971,20171104164042429462908）'
    showAgreement(order) {
      return order.status === 'PAY_CONFIRMED' && order.serialNumber != '201708061155448578424500' && order.serialNumber != '201701101459098598989971' && order.serialNumber != '20171104164042429462908'
    },
    // 判断是否显示收货地址
    showShippingAddress(order) {
      return (order.ipadPresentOrder && order.confirmShipAddress && order.shipAddress && order.orderShipAddressStatus && order.status === 'PAY_CONFIRMED' && order.refundStatus != 'REFUND_ING' && order.refundStatus != 'REFUND_SUCCESS') || (!order.ipadPresentOrder && order.shipAddress)
    },
    // 判断是否展示“立即确认收货地址”按钮
    showShippingAddressAtOnceBtn(order) {
      return order.ipadPresentOrder && order.confirmShipAddress && !order.orderShipAddressStatus && order.status === 'PAY_CONFIRMED' && order.refundStatus != 'REFUND_ING' && order.refundStatus != 'REFUND_SUCCESS'
    },
    // 是否订单拆分
    isSplitOrder(order) {
      return order.open && order.status != 'CANCELED' && order.followType == 2
    },
    isSplitOrder2(order) {
      return order.open && order.status != 'CANCELED' && order.followType != 2 && order.refundStatus != 'REFUND_SUCCESS' && order.refundStatus != 'REFUND_ING'
    },
    getAgreement(v, studentId, versions,serialNumber) {
      this.$emit('getAgreement', v, studentId, versions,serialNumber)
    },
    sureAddress(studentId, orderId) {
      this.$emit('sureAddress', studentId, orderId)
    },
    cancelPay({ id, old, deposit }) {
      this.$emit('cancelPay', { id, old, deposit })
    }
  }
}
</script>

<style lang="less" scoped>
.order-item-component {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 15px;

  .hour-num {
    display: inline-block;
    padding-left: 11px;
    background: url("../../../../assets/images/order/bg.png") no-repeat -123px -43px;
  }
  .tip-info {
    color: #999999;
    margin-top: 3px;
  }
  .action-btn {
    display: inline-block;
    width: 80px;
    height: 30px;
    cursor: pointer;
    background-color: #f60;
    line-height: 28px;
    border: 1px solid #b74900;
    font-weight: 700;
    border-radius: 3px;
    margin: 3px 0;
    text-align: center;
    color: #fff;
    &.btn-disabled {
      background-color: #b9b9b9;
      border: 1px solid #8f8f8f;
      cursor: not-allowed;
    }
  }
  .contacts-person {
    color: #999;
  }

  table {
    &.order-table {
      font-size: 14px;
      margin: 0 0 -1px -1px;
      width: 100%;
      /deep/.price {
        font-weight: 700;
      }
      .agreement-a {
        display: block;
        font-size: 12px;
        &.click-a {
          color: #4a90e2;
          cursor: pointer;
          &:hover {
            color: #e65;
          }
        }
      }
      tr {
        td {
          border-left: 1px solid #e0e0e0;
          border-bottom: 1px solid #e0e0e0;
          line-height: 24px;
        }
        &:nth-of-type(1) {
          td:nth-of-type(1) {
            ul {
              li {
                border-bottom: 1px solid #e0e0e0;
                padding: 13px 20px;
                height: 50px;
                span {
                  font-weight: 400;
                  display: inline-block;
                  &.free {
                    margin-left: 5px;
                    font-size: 12px;
                    background-color: #f60;
                    color: #fff;
                    height: 20px;
                    width: 20px;
                    line-height: 20px;
                    text-align: center;
                    border-radius: 3px;
                  }
                }
                &:last-child {
                  border-bottom: 0;
                }
              }
            }
          }
        }

        &.tr-row {
          height: 58px;
          td {
            border-left: 0;
            text-align: center;
            .price {
              color: #f60;
              font-weight: 700;
              span {
                color: #f60;
              }
            }
          }
        }
      }
      .tr-4 {
        td:nth-of-type(1) {
          width: 500px;
        }
        td:nth-of-type(2) {
          width: 118px;
        }
        td:nth-of-type(3) {
          width: 119px;
        }
        td:nth-of-type(4) {
          width: 135px;
        }
      }
      .tr-5 {
        td:nth-of-type(1) {
          width: 450px;
        }
        td:nth-of-type(2) {
          width: 118px;
        }
        td:nth-of-type(4) {
          width: 119px;
        }
        td:nth-of-type(5) {
          width: 135px;
        }
      }
    }
  }

  .table-footer {
    height: 50px;
    font-size: 12px;
    td {
      padding-left: 20px;
      .policy-module {
        display: inline-block;
        margin-right: 20px;
        line-height: 18px;
        height: 18px;
        cursor: pointer;
        .hook-img {
          margin-bottom: -3px;
          height: 15px;
          width: 15px;
        }
        span {
          height: 100%;
        }
      }
    }
  }
  .address-info-module {
    p {
      &:first-child {
        margin-bottom: 5px;
      }
    }
    .contacts-person {
      color: #999;
      span {
        display: inline-block;
        color: #999;
        margin-right: 10px;
        &.order-body-list-btn {
          border: 1px solid #b74900;
          font-weight: 700;
          background-color: #ccc;
          border-radius: 3px;
          margin-top: 10px;
          margin-bottom: 3px;
          font-size: 14px;
          height: 30px;
          line-height: 28px;
          width: 100px;
          text-align: center;
          color: #fff;
        }
      }
    }
  }
  // 可能是无用的
  .div-table {
    p:nth-of-type(1) {
      width: 503px;
    }
    p:nth-of-type(2) {
      width: 132px;
    }
    p:nth-of-type(3) {
      width: 133px;
    }
    p:nth-of-type(2) {
      width: 152px;
    }
  }
}
</style>
